"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./loading-indicator.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable complexity, max-statements */
var timeToFade = 250;
var timeToSlideToCenter = 500;

/**
 * A general-purpose loading indicator for use during data requests
 * and errors are displayed to users.
 */

var LoadingIndicator = function LoadingIndicator(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error;
  var elementRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)({
      failure: error,
      working: active,
      fast: error && !active,
      fade: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var addAnimationListener = function addAnimationListener(callback) {
    elementRef.current.addEventListener('animationiteration', callback);
  };
  var removeAnimationListener = function removeAnimationListener(callback) {
    elementRef.current.removeEventListener('animationiteration', callback, false);
  };
  var startWorking = function startWorking() {
    setState({
      working: true,
      fast: false
    });
  };
  var _stopAfterIteration = function stopAfterIteration() {
    setState({
      working: false,
      failure: false,
      fade: false,
      fast: false
    });
    removeAnimationListener(_stopAfterIteration);
  };
  var stopWorking = function stopWorking() {
    addAnimationListener(_stopAfterIteration);
  };
  var _switchTofailureAfterIteration = function switchTofailureAfterIteration() {
    setState({
      failure: true
    });
    removeAnimationListener(_switchTofailureAfterIteration);
  };
  var switchToFailure = function switchToFailure() {
    addAnimationListener(_switchTofailureAfterIteration);
  };
  var showFailure = function showFailure() {
    setState({
      fade: true,
      failure: false,
      working: false,
      fast: false
    });
    setTimeout(function () {
      setState({
        fast: true
      });
      setTimeout(function () {
        setState({
          fade: false,
          failure: true
        });
      }, timeToSlideToCenter);
    }, timeToFade);
  };
  var switchToWorking = function switchToWorking() {
    setState({
      working: false,
      fade: false,
      fast: true
    });
    setTimeout(function () {
      setState({
        fade: true
      });
      setTimeout(function () {
        setState({
          working: true,
          failure: false,
          fade: false,
          fast: false
        });
      }, timeToFade);
    }, 0);
  };
  var fadeOut = function fadeOut() {
    setState({
      fade: true,
      working: false,
      fast: true
    });
    setTimeout(function () {
      setState({
        working: false,
        failure: false,
        fade: false,
        fast: false
      });
    }, timeToFade);
  };
  (0, _react.useEffect)(function () {
    return function () {
      if (elementRef.current) {
        removeAnimationListener(_stopAfterIteration);
        removeAnimationListener(_switchTofailureAfterIteration);
      }
    };
  }, []);
  if (!state.failure && error) {
    if (state.working) {
      switchToFailure();
    } else {
      showFailure();
    }
  } else if (state.failure && !error) {
    if (active) {
      switchToWorking();
    } else {
      fadeOut();
    }
  } else if (!state.working && active) {
    if (!state.failure) {
      startWorking();
    }
  } else if (state.working && !active) {
    if (state.failure) {
      setState({
        working: false
      });
    } else {
      stopWorking();
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: (0, _classnames["default"])('position-fixed sb-loadingIndicator', {
      hidden: !state.working
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('position-relative', {
      'sb-loadingIndicatorStatus--fast': state.fast,
      'sb-loadingIndicatorStatus--slow': !state.fast,
      'sb-loadingIndicatorStatus--working': state.working,
      'sb-loadingIndicatorStatus--failure': state.failure,
      'sb-loadingIndicatorStatus--fade': state.fade
    }),
    ref: elementRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'position-relative sb-loadingIndicator-stripe'
  })));
};
LoadingIndicator.displayName = 'LoadingIndicator';
LoadingIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A flag indicating that the loading indicator is active and should be displayed.
   */
  active: _propTypes["default"].bool,
  /**
   * A flag indicating there is an error is currently being displayed to the user.
   */
  error: _propTypes["default"].bool
} : {};
var _default = exports["default"] = LoadingIndicator;